// Sub-route adapters for the Insurance section. Each one reads from
// InsuranceSectionContext and passes the values down to the existing
// component as props — keeps PolicyList / RenewalCalendar decoupled
// from the section context.

import PolicyList from '../../components/Insurance/PolicyList';
import RenewalCalendar from '../../components/Insurance/RenewalCalendar';
import { useInsuranceSection } from './InsuranceSection';

export function PoliciesRoute() {
  const { refreshKey, selectedState, setSelectedState, openEditPolicy } = useInsuranceSection();
  return (
    <PolicyList
      key={refreshKey}
      onEdit={openEditPolicy}
      stateFilter={selectedState}
      onStateFilterChange={setSelectedState}
    />
  );
}

export function RenewalsRoute() {
  const { refreshKey } = useInsuranceSection();
  return <RenewalCalendar key={refreshKey} />;
}

export function QuotesRoute() {
  return (
    <div className="bg-white rounded-[4px] shadow-[0_2px_6px_rgba(0,0,0,0.07)] p-12 text-center">
      <p className="text-[14px] text-[#888]">Quote comparison view -- coming with EZLynx integration</p>
    </div>
  );
}
